import R from 'ramda';
import { handleActions } from 'redux-actions';
import { Actions } from '../constants';

const payloadKeys = [
  'currency',
  'priceDistribution',
  'priceMax',
  'priceMin',
  'trimmedPriceDistribution',
  'trimmedPriceMax',
  'trimmedPriceMin',
];

const defaultCurrency = 'EUR';

const initialState = {
  currency: defaultCurrency,

  priceDistribution: [],
  priceMax: null,
  priceMin: null,

  trimmedPriceDistribution: [],
  trimmedPriceMax: null,
  trimmedPriceMin: null,

  value: {
    max: null,
    min: null,
  },
};

export default handleActions(
  {
    [Actions.LOAD_DONE]: (state, { payload }) => ({
      ...state,
      ...R.pick(payloadKeys, payload),
    }),

    [Actions.UPDATE_SEARCH_PARAMS]: (
      state,
      { payload: { priceMax, priceMin, currency = defaultCurrency } },
    ) => ({
      ...state,
      currency,
      value: {
        max: R.isNil(priceMax) ? null : parseInt(priceMax, 10),
        min: R.isNil(priceMin) ? null : parseInt(priceMin, 10),
      },
    }),
  },
  initialState,
);
